module.exports = __webpack_public_path__ + "static/img/cont49 (5).682622f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (5).jpg
// module id = v/v0
// module chunks = 0